import { render } from "./vh-multi-bar-chart.vue?vue&type=template&id=183c83c1"
import script from "./vh-multi-bar-chart.vue?vue&type=script&lang=js"
export * from "./vh-multi-bar-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__